module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/foreword"
    }
  }, [_vm._v("Foreword, by C. Donald Cook")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/acknowledgement"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/chapter01"
    }
  }, [_c('b', [_vm._v("1. B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ASKETBALL")]), _vm._v(": I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("T")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONNECTICUT")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AME")]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OO")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("2. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAYERS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chuck Aleksinas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Bagley")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vin Baker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mike Branch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alvin Clinkscales")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Johnny Egan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ed Goldstone")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tony Hanson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Walter Luckett")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wes Matthews")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Calvin Murphy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ralph Paolillo")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Charles Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chris Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Porky Vieira")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter02#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("John Williamson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("3. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OACHES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fred Barakat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frank Crisafi")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bill Detrick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dee Rowe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harrison Taylor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Joe Vancisin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter03#h7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Red Verderame")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("4. T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAMS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bassick High School, 1988–89")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("University of Connecticut, 1975–76")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fairfield University, 1977–78")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roger Ludlowe High School, 1954–55")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacred Heart University, 1985–86")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#h6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wilbur Cross High School, 1971–72")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("5. R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AY")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NDRADE")]), _vm._v(": T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVIL")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIVES")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/appendix",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix. Records")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31f1d30c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0